<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Pick some filters</h2>
      <p>What cases do you want to see in your bucket?</p>
    </v-flex>
    <v-flex>
      <v-layout v-for="(filter, i) in bucket.criteria" :key="i" row>
        <bucket-filter :filter="filter" :schema="schema"></bucket-filter>
      </v-layout>
      <v-layout row>
        <v-btn
          class="ml-0 mt-0"
          id="createFilter-btn"
          color="secondary"
          @click="appendFilterField()">
          Add a New Filter
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BucketFilter from "@/components/buckets/bucket-edit/Fields/BucketFilter.vue"

export default {
  components: { BucketFilter },
  props: {
    bucket: {
      type: Object,
      required: true
    },
    caseType: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    }
  },
  methods: {
    appendFilterField() {
      this.$store.dispatch("addNewFilterField", this.field)
    }
  }
}
</script>
